import { Badge, BadgeSize, BadgeVariant } from "shared/components";
import type { LockboxVerificationStatus } from "api/landlord/lockboxes/types";
import { VERIFICATION_STATUS_LABELS } from "../constants";

const STATUS_VARIANT: Record<LockboxVerificationStatus, BadgeVariant> = {
  verified: BadgeVariant.SUCCESS,
  failed: BadgeVariant.ERROR,
  not_verified: BadgeVariant.BASE
};

interface VerificationStatusPillProps {
  status: LockboxVerificationStatus;
}

export const VerificationStatusPill = ({
  status
}: VerificationStatusPillProps) => (
  <Badge variant={STATUS_VARIANT[status]} size={BadgeSize.SM}>
    {VERIFICATION_STATUS_LABELS[status]}
  </Badge>
);
